import { Action } from '@ngrx/store';

import { FetchFromLocalStorage } from '../../helpers/fetch-from-local-storage.helper';
import { OauthAction, OauthActionTypes, SetOauth } from './oauth.actions';
import { OauthState } from './state';

export const initialState: OauthState | null = FetchFromLocalStorage('oauth') ?? null;

export function reducer(state = initialState, action: Action): OauthState | null {
    const specificAction: OauthAction = action as OauthAction;

    switch (specificAction.type) {
        case OauthActionTypes.SetOauth:
            return { ...state, ...(action as SetOauth).payload };
        case OauthActionTypes.UnsetOauth:
            return null;

        default:
            return state;
    }
}
